import Base from "@/core/base/BaseFilter";
export default class Filter extends Base {
  Id: 0;

  n: "";
}
